import { Customer } from "@/models/response/customer";
import { Avatar, Checkbox, Group, Paper, Stack, Text } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";

type Props = {
  customer: Customer;
  showDetails?: boolean;
  setSelectedCustomer: (customer: Customer | null) => void;
};

function CustomerItem({
  customer,
  showDetails = true,
  setSelectedCustomer,
}: Props) {
  return (
    <Paper p="md" radius="md" onClick={() => setSelectedCustomer(customer)}>
      <Group justify="space-between">
        <Group justify="space-between">
          <Group>
            {!showDetails && <Checkbox checked readOnly />}
            <Avatar color="blue" radius="xl" size="lg">
              {customer?.firstName?.charAt(0) || ""}
            </Avatar>
            {/* <Avatar color="blue" radius="sm">
              <GenderAvatar gender={customer?.gender} />
            </Avatar> */}
            <Stack gap="0">
              <Text size="md">{customer.phoneNumber}</Text>
              {
                <Text size="xs" c="gray">{`${customer?.firstName || ""} ${
                  customer?.lastName || ""
                }`}</Text>
              }
            </Stack>
          </Group>
        </Group>
        {showDetails && (
          <Group gap="2" justify="end">
            <Text size="xs">انتخاب</Text>
            <IconChevronLeft size="10px" />
          </Group>
        )}
      </Group>
    </Paper>
  );
}

export default CustomerItem;
